<div #map class="map-wrapper"></div>

<div #topLeftButtonsWrapper *ngIf="mapLoaded && !readonly" class="tools-container-wrapper">
  <app-my-location-btn
    [showLabel]="false"
    (locationAvailableEvent)="onMyLocationAvailable($event)"
  ></app-my-location-btn>

  <app-map-search #searchControl
    [map]="gmap"
    (autocompleteResult)="onAutocompleteResult($event)"
  >
  </app-map-search>
</div>
